<template>
  <div>
    <!--<div>-->
    <!--<PdfViewerComp bookName="bookName"></PdfViewerComp>-->
    <!--</div>-->
    <!--<DrawingComp/>-->
    <div id="tab-sidebar-pate4">
      <div class="container">
        <div id="menu-tab-pate4" class="row">
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
            <router-link
              :to="{
                name: 'ebook-detail',
                params: { id: this.id, slug: this.slug },
              }"
              class="cancle-view"
            >
              <i class="fa fa-times"></i> Thoát
            </router-link>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
            <h2 class="title-book">
              {{
                this.title != null
                  ? this.title
                  : this.ebooksDetail != null
                  ? this.ebooksDetail.name
                  : ""
              }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <input
      ref="shortcutKey"
      style="opacity: 0; position: absolute"
      type="text"
      @keyup.right="next"
      @keyup.left="prev"
    />

    <div class="container-fluid">
      <div class="row content-main-test">
        <div class="nav-left-list" v-show="isShowMenu">
          <p>Mục lục</p>
          <hr width="85%" />
          <div class="ebook-left">
            <div v-if="ebooksDetail != null && ebooksDetail.bookIndexs != null">
              <div class="chapter" v-for="chapter in ebooksDetail.bookIndexs">
                <a
                  @click="
                    readPage(
                      chapter.pageNo != null
                        ? chapter.pageNo > numPages
                          ? numPages
                          : chapter.pageNo
                        : 0,
                      (chapter.title !== null ? chapter.title + ': ' : '') +
                        (chapter.name !== null ? chapter.name : ''),
                      chapter.id
                    )
                  "
                  class="chapter_title"
                  data-toggle="collapse"
                  href="#"
                  aria-expanded="true"
                >
                  {{
                    (chapter.title !== null ? chapter.title + " : " : "") +
                    chapter.name
                  }}
                  <!--{{chapter.name}}-->
                </a>
                <div class="collapse show" id="chapter1">
                  <ul>
                    <li v-for="lesson in chapter.bookIndexChilds">
                      <a
                        :class="lessonId == lesson.bookIndexId ? 'active' : ''"
                        href="#"
                        @click="
                          readPage(
                            lesson.pageNo != null
                              ? lesson.pageNo > numPages
                                ? numPages
                                : lesson.pageNo
                              : 0,
                            (lesson.title !== null ? lesson.title + ': ' : '') +
                              (lesson.name !== null ? lesson.name : ''),
                            lesson.id
                          )
                        "
                      >
                        <!--{{(lesson.title!==null?lesson.title + " : ":"")+lesson.name}}-->
                        {{ lesson.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- test -->
        <div class="content-test mt-4 content-ebook">
          <div class="chevron-next">
            <a
              @click="prev"
              href="javascript:void(0)"
              role="button"
              data-slide="prev"
            >
              <img src="@/assets/images/prev.png" alt="Trang trước" />
            </a>
          </div>
          <div>
            <div
              v-if="displayTwoPage"
              class="book-container"
              :class="{ 'flipbook-open': activeFlipBook > 0 }"
            >
              <div
                class="cover"
                v-if="page > 0"
                v-for="(item, index) in pageBookDefault"
                :class="{
                  'flip-left': activeFlipBook > index,
                  'flip-right': activeFlipBook <= index,
                  'flip-right-first': activeFlipBook === index,
                }"
                ref="cover_book_page"
              >
                <figure
                  v-if="index * 2 + 2 <= numPages"
                  class="front"
                  :style="{ opacity: setOpacityActiveFlip === index ? 1 : 0 }"
                >
                  <div ref="container_page">
                    <pdf
                      :src="`${appUrl}${slug}-${
                        index === 0 ? index * 2 + 1 : index * 2 + 2
                      }.pdf`"
                      :key="index === 0 ? index * 2 + 1 : index * 2 + 2"
                      :id="index === 0 ? index * 2 + 1 : index * 2 + 2"
                      :page="1"
                      :annotation="true"
                      :scale.sync="scale"
                      style="width: 100%"
                    >
                      <template slot="loading" class="loading-pdf">
                        Đang tải...
                      </template>
                    </pdf>
                  </div>
                </figure>
                <figure class="back" v-if="index * 2 + 3 <= numPages">
                  <div ref="container_page">
                    <pdf
                      :src="`${appUrl}${slug}-${index * 2 + 3}.pdf`"
                      :key="index * 2 + 3"
                      :id="index * 2 + 3"
                      :page="1"
                      :annotation="true"
                      :scale.sync="scale"
                      style="width: 100%"
                    >
                      <template slot="loading" class="loading-pdf">
                        Đang tải...
                      </template>
                    </pdf>
                  </div>
                </figure>
              </div>
            </div>
            <div v-else class="book-view-single position-rel">
              <div
                class="cover"
                v-if="page > 0"
                v-for="(item, index) in pageBookDefault"
                :class="{
                  'flip-left': activeFlipBook > index,
                  'flip-right': activeFlipBook <= index,
                  'flip-right-first': activeFlipBook === index,
                }"
                ref="cover_book_page"
              >
                <figure
                  class="front"
                  :style="{ opacity: setOpacityActiveFlip === index ? 1 : 0 }"
                >
                  <div ref="container_page">
                    <pdf
                      :src="`${appUrl}${slug}-${item}.pdf`"
                      :key="item"
                      :id="item"
                      :page="1"
                      :annotation="true"
                      :scale.sync="scale"
                      style="width: 100%"
                    >
                      <template slot="loading" class="loading-pdf">
                        Đang tải...
                      </template>
                    </pdf>
                  </div>
                </figure>
              </div>
            </div>
          </div>
          <div class="chevron-next">
            <a
              @click="next"
              href="javascript:void(0)"
              role="button"
              data-slide="next"
            >
              <img src="@/assets/images/next.png" alt="Trang tiếp theo" />
            </a>
          </div>
        </div>

        <div class="main-content-pate4" v-if="isShowTools">
          <div>
            <button
              id="search"
              type="button"
              @click="showSearch"
              :class="isShowSearch ? 'icon-button btn-active' : 'icon-button'"
            >
              <i class="fa fa-search"></i>
            </button>
            <br />
            <button
              id="note"
              type="button"
              @click="showNote"
              :class="isShowNote ? 'icon-button btn-active' : 'icon-button'"
            >
              <i class="fa fa-file-alt"></i>
            </button>
            <br />
            <button
              id="link"
              type="button"
              @click="showLinkShare"
              :class="
                isShowLinkShare ? 'icon-button btn-active' : 'icon-button'
              "
            >
              <i class="fa fa-link"></i>
            </button>
            <br />
            <button
              id="pen"
              type="button"
              @click="showColorPen"
              :class="isShowColorPen ? 'icon-button btn-active' : 'icon-button'"
            >
              <i class="fa fa-pencil-alt"></i>
            </button>
            <div class="color-pen" v-show="isShowColorPen">
              <button
                type="button"
                :class="
                  defaultColor == 'gray'
                    ? 'btn btn-secondary active'
                    : 'btn btn-secondary'
                "
                @click="setColor('gray')"
              ></button>
              <br />
              <button
                type="button"
                :class="
                  defaultColor == 'red'
                    ? 'btn btn-danger active'
                    : 'btn btn-danger'
                "
                @click="setColor('red')"
              ></button>
              <br />
              <button
                type="button"
                :class="
                  defaultColor == 'yellow'
                    ? 'btn btn-warning active'
                    : 'btn btn-warning'
                "
                @click="setColor('yellow')"
              ></button>
              <br />
              <button
                type="button"
                :class="
                  defaultColor == 'green'
                    ? 'btn btn-success active'
                    : 'btn btn-success'
                "
                @click="setColor('green')"
              ></button>
              <br />
              <button
                type="button"
                :class="
                  defaultColor == 'blue'
                    ? 'btn btn-info active'
                    : 'btn btn-info'
                "
                @click="setColor('blue')"
              ></button>
            </div>
          </div>
          <div class="nav-left-list search-tab" v-show="isShowSearch">
            <p class="tracuu">Tra cứu</p>
            <div class="search-of-right">
              <input type="text" placeholder="Tìm kiếm" v-model="textSearch" />
              <i class="fa fa-search" @click="searchText"></i>
            </div>
            <hr width="85%" />
            <div class="m-3">
              <b-tabs content-class="mt-3" justified>
                <b-tab title="Trang" active>
                  <div
                    class="p-3 mb-3 bg-white rounded"
                    v-for="post in searchResult"
                  >
                    <a
                      href="javascript:void(0)"
                      @click="readPage(post.pageNo - 1, '', 0)"
                    >
                      Trang {{ post.pageNo - 1 }}
                    </a>
                  </div>
                </b-tab>
                <b-tab title="Nội dung">
                  <div
                    class="p-3 mb-3 bg-white rounded"
                    v-for="post in searchResult"
                  >
                    <a
                      href="javascript:void(0)"
                      @click="readPage(post.pageNo - 1, '', 0)"
                    >
                      <div v-for="highLight in post.highLights">
                        <span v-html="highLight"></span>
                      </div>
                    </a>
                  </div>
                </b-tab>
                <b-tab title="Bài"
                  ><p>I'm the tab with the very, very long title</p></b-tab
                >
              </b-tabs>
            </div>
          </div>
          <div class="nav-left-list search-tab note-help" v-show="isShowNote">
            <p class="tracuu">Bảng ghi chú</p>
            <hr width="85%" />
            <div class="m-3">
              <b-tabs content-class="mt-3" justified>
                <b-tab title="Đánh dấu" active>
                  <div v-for="hl in getDictHighLight(page)">
                    <i
                      class="fa fa-times-circle highlight-close"
                      @click="removeHighLight(hl)"
                    ></i>
                    <span :class="'highlight-note highlight-' + hl.color">
                      {{ hl.content }}
                    </span>
                  </div>
                </b-tab>
                <b-tab title="Ghi chú">
                  <div
                    class="p-3 mb-3 bg-white rounded"
                    v-for="post in searchResult"
                  >
                    <a
                      href="javascript:void(0)"
                      @click="readPage(post.pageNo - 1, '', 0)"
                    >
                      <div v-for="highLight in post.highLights">
                        <span v-html="highLight"></span>
                      </div>
                    </a>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
          <div class="nav-left-list table-note" v-show="isShowLinkShare">
            <p class="tracuu">Link liên kết</p>
            <hr width="85%" />
            <div class="search-of-right">
              <input type="text" placeholder="Tìm kiếm" />
              <i class="fa fa-search"></i>
            </div>
            <div class="note-help">
              <p v-show="getLesson(slide) > 0">
                <a
                  href="javascript:void(0)"
                  @click="luyenTap(getLesson(slide))"
                  class="word active"
                  >Luyện tập trang {{ slide }}</a
                >
              </p>
            </div>
            <div class="note-help">
              <p v-show="getLesson(slide + 1) > 0">
                <a
                  href="javascript:void(0)"
                  @click="luyenTap(getLesson(slide + 1))"
                  class="word active"
                  >Luyện tập trang {{ slide + 1 }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer-pate4">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-2 col-xl-4 list-exam">
            <button
              @click="showMenu"
              id="danhsach"
              class="btn btn-primary"
              type="button"
              v-if="isShowTableContent"
            >
              <span><i class="fa fa-bars"></i> Mục lục</span>
            </button>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-10 col-xl-8 next-footer-ebook">
            <div
              class="
                action-book
                display-flex-center
                justify-content-between
                full-width
              "
            >
              <div id="next-page-ebook">
                <!--<a href="javascript:void(0)" @click="luyenTap" v-show="id==115" class="word active">Luyện tập</a>-->
                <button @click="first">
                  <i class="fa fa-backward"></i>
                </button>
                <button @click="prev">
                  <i class="fa fa-caret-left"></i>
                </button>
                <span
                  class="show-pages"
                  v-if="activeFlipBook !== 0 && displayTwoPage"
                >
                  <!-- {{ (activeFlipBook * 2) - 1 }} - {{ activeFlipBook * 2 }} -->
                  {{ activeFlipBook * 2 }} - {{ activeFlipBook * 2 + 1 }}
                </span>
                <span class="show-pages" v-else-if="!displayTwoPage">
                  {{ activeFlipBook }}
                </span>
                <span class="show-pages text-center" v-else>0</span>
                <!-- <input type="text" :value="page + ' / ' + numPages" disabled="disabled"> -->
                <button @click="next">
                  <i class="fa fa-caret-right"></i>
                </button>
                <button @click="last">
                  <i class="fa fa-forward"></i>
                </button>
              </div>
              <div class="action-right display-flex-center">
                <div id="zoom-ebook">
                  <button @click="zoomOut">-</button>
                  <span>{{ Math.ceil(scale * 100) }} %</span>
                  <!-- <input type="text" :value="scale*100" disabled="disabled" v-on:keyup.enter="trySetNewZoom"> -->
                  <button @click="zoomIn">+</button>
                </div>
                <div class="switch-viewpage">
                  <input
                    type="checkbox"
                    name="change_view"
                    @change="changeViewBook"
                    checked
                  />
                  <span class="bg-transition"></span>
                  <label class="view-single">
                    <i class="fas fa-file-alt"></i>
                  </label>
                  <label class="view-double">
                    <i class="fas fa-book-open"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-exercise" v-model="isShowExercise" centered size="xl">
      <div>
        <!-- <ExerciseSubjectDetail :questionId="lessonId"></ExerciseSubjectDetail> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
class Post {
  constructor(title, link, author, img) {
    this.title = title;
    this.link = link;
    this.author = author;
    this.img = img;
  }
}

import { mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
//import moment from 'moment'
//import store from '../_store'
//import DrawingComp from './DrawingComp'
//import ExerciseSubjectDetail from './ExerciseSubjectDetail'

import PdfViewerComp from "../../../libs/PdfViewerComp.vue";
import PdfViewer from "../../../libs/PdfViewer.vue";
import pdfvuer from "pdfvuer";
import { APP_CONFIG } from "@/utils/constants";

//import Carousel from './Carousel'

export default {
  name: "EBookReadBook",
  components: {
    //DrawingComp,
    //ExerciseSubjectDetail,
    PdfViewerComp,
    PdfViewer,
    pdf: pdfvuer,
    //Carousel
  },
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
      slide: 0,
      pageSlides: [
        { id: "1", pathUrl: "toan_lop-5_001.jpg", name: "Tiêu đề 001" },
      ],
      sliding: null,
      isShowTools: false,
      isShowTableContent: false,
      isShowMenu: false,
      isShowSearch: false,
      isShowNote: false,
      isShowLinkShare: false,
      isShowColorPen: false,
      title: null,
      isShowExercise: false,
      //zoom: 50,
      lessonId: 0,
      textSearch: "",
      postList: [],
      pdfdata: null,
      show: true,
      page: this.defaultPage,
      src: "http://localhost:8011/bt-toan-5-tap-hai-protected.pdf",
      size: {
        width: -1,
        height: -1,
      },
      numPages: 0,
      pdfDoc: null,
      zoom: 50,
      pdfObj: null,
      scale: "page-width",

      x: 0,
      y: 0,
      showTools: false,
      selectedText: "",
      dictHighLight: {},
      defaultColor: "red",
      bookCdnUrl: APP_CONFIG.bookCdnUrl,
      defaultPage: 1,
      dynamicKey: 1,
      resetPages: true,
      articles: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      flipClass: "",
      appUrl: APP_CONFIG.bookCdnUrl,
      eachPageDouble: 1,
      eachPageSingle: 2,
      pageBookDefault: 0,
      activeFlipBook: 0,
      setOpacityActiveFlip: 0,
      widthPage: 0,
      heightPage: 0,
      displayTwoPage: true,
    };
  },
  computed: {
    ...mapGetters({
      ebooksDetail: STORE_KEY + "/ebooksDetail",
      searchResult: STORE_KEY + "/searchResult",
    }),
    filteredList: function () {
      return this.postList.filter((post) => {
        return post.title.toLowerCase().includes(this.textSearch.toLowerCase());
      });
    },
    getHighLights: function () {
      return this.getDictHighLight(this.page);
    },
    // keymap () {
    //     return {
    //         'key': this.page,
    //     }
    // }
  },
  watch: {
    scale(val) {
      // Set width & height for book viewer
      this.$refs.container_page && this.setWidthHeightBookViewer();
    },
    page(val) {
      // Set width & height for book viewer
      this.$refs.container_page && this.setWidthHeightBookViewer();
    },
  },
  created() {
    window.addEventListener("keyup", this.onKeyup);
  },
  mounted() {
    //this.$refs.shortcutKey.focus()
    this.$store.dispatch(STORE_KEY + "/getEBooksDetail", this.id);
    this.setWidthBookDefault();
    this.getPdf(this.defaultPage);
    window.addEventListener("mouseup", this.onMouseup);
    // console.log('MOUNTED: ', document.getElementsByClassName('book-container')[0].clientHeight, document.getElementsByClassName('book-container')[0].clientWidth);
  },
  beforeDestroy() {
    window.removeEventListener("mouseup", this.onMouseup);
    window.removeEventListener("keyup", this.onKeyup);
  },

  methods: {
    setWidthBookDefault() {
      if (
        !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        let bookContainer = !this.displayTwoPage
          ? document.getElementsByClassName("book-view-single")[0]
          : document.getElementsByClassName("book-container")[0];
        if (!this.displayTwoPage) {
          bookContainer.style.marginLeft = 0;
        } else {
          bookContainer.style.marginLeft = `${widthBook}px`;
        }
        let heightBook = bookContainer.clientHeight;
        let numPercentWidthHeight = 1.55;
        let widthBook = heightBook / numPercentWidthHeight;
        bookContainer.style.width = `${widthBook}px`;
      }
    },

    setWidthHeightBookViewer() {
      setTimeout(() => {
        // let lengthContentPage = this.$refs.container_page.length;
        let refCoverDiv = this.$refs.cover_book_page;
        let pagesCover;
        if (this.displayTwoPage) {
          pagesCover = document.querySelectorAll(".book-container .page");
        } else {
          pagesCover = document.querySelectorAll(".book-view-single .page");
        }
        // console.log('PAGE COVER : ', document.getElementsByClassName('book-container')[0].clientHeight, document.getElementsByClassName('book-container')[0].clientWidth);
        // let pageCover = document.querySelector('.book-container .page');
        let lengthPagesCover = pagesCover.length;
        let pagesCoverFirst = pagesCover[0];
        let pagesCoverLast = pagesCover[lengthPagesCover - 1];
        let widthClient = pagesCoverLast.clientWidth;
        let heightClient = pagesCoverLast.clientHeight;
        let elementOpenBook = document.getElementsByClassName("flipbook-open");

        if (this.displayTwoPage && elementOpenBook.length === 0) {
          widthClient = pagesCoverFirst.clientWidth;
          heightClient = pagesCoverFirst.clientHeight;
        }
        this.widthPage = widthClient;
        this.heightPage = heightClient;
        // console.log('OPEN FLIP: ', elementOpenBook, widthClient, heightClient);

        if (elementOpenBook.length > 0) {
          elementOpenBook[0].style.marginLeft = `${widthClient}px`;
        } else {
          if (document.getElementsByClassName("book-container").length > 0) {
            document.getElementsByClassName(
              "book-container"
            )[0].style.marginLeft = 0;
          }
          if (document.getElementsByClassName("book-view-single").length > 0) {
            document.getElementsByClassName(
              "book-view-single"
            )[0].style.marginLeft = 0;
          }
        }
        if (!this.displayTwoPage) {
          document.getElementsByClassName(
            "book-view-single"
          )[0].style.width = `${widthClient}px`;
          document.getElementsByClassName(
            "book-view-single"
          )[0].style.marginLeft = 0;
        } else {
          document.getElementsByClassName(
            "book-container"
          )[0].style.width = `${widthClient}px`;
        }
        if (refCoverDiv) {
          refCoverDiv.map((cover) => {
            cover.style.width = `${widthClient}px`;
            cover.style.height = `${heightClient}px`;
          });
        }
      }, 1000);
    },
    //
    // Zooming page functions
    //
    changeZoomLevel(nz) {
      var newzoom = this.zoom + 10 * (nz > 0 ? 1 : -1);
      if (newzoom >= 500) {
        newzoom = 500;
      } else if (newzoom <= 0) {
        newzoom = 5;
      }
      this.zoom = newzoom;
    },

    trySetNewZoom(ev) {
      var z = parseFloat(ev.target.value);
      if (isNaN(z)) {
        ev.target.value = "" + this.zoom;
        return;
      }

      this.zoom = z;
    },
    slideStyle() {
      return {
        width: "" + this.zoom + "%",
      };
    },
    pageUrl(index) {
      //      if(this.id==115){
      ////      if(parseInt(index)>=3 && parseInt(index)<186){
      ////        index=parseInt(index)+1;
      ////      }
      //        return require(`@/assets/images/bai-tap-toan_lop-5_${this.padZeroes(index,3)}.jpg`);
      //      }
      //return require(`@/assets/books/${this.ebooksDetail.slug}_${this.padZeroes(index, 3)}.jpg`);
      return "";
    },
    showMenu() {
      this.isShowMenu = !this.isShowMenu;
      if (this.isShowMenu) {
        this.isShowSearch = false;
        this.isShowNote = false;
        this.isShowColorPen = false;
        this.isShowLinkShare = false;
      }
    },
    showSearch() {
      this.isShowSearch = !this.isShowSearch;
      if (this.isShowSearch) {
        this.isShowMenu = false;
        this.isShowNote = false;
        this.isShowColorPen = false;
        this.isShowLinkShare = false;
      }
    },
    showNote() {
      this.isShowNote = !this.isShowNote;
      if (this.isShowNote) {
        this.isShowMenu = false;
        this.isShowSearch = false;
        this.isShowColorPen = false;
        this.isShowLinkShare = false;
      }
    },
    showLinkShare() {
      this.isShowLinkShare = !this.isShowLinkShare;
      if (this.isShowLinkShare) {
        this.isShowMenu = false;
        this.isShowSearch = false;
        this.isShowColorPen = false;
        this.isShowNote = false;
      }
    },
    showColorPen() {
      this.isShowColorPen = !this.isShowColorPen;
      if (this.isShowColorPen) {
        this.isShowMenu = false;
        this.isShowSearch = false;
        this.isShowNote = false;
        this.isShowLinkShare = false;
      }
    },
    getPdf(page) {
      var self = this;

      self.pdfdata = "";
      //document.getElementById('pdfvuer').removeChild()
      //self.pdfdata = pdfvuer.createLoadingTask(APP_CONFIG.bookCdnUrl + 'toan-5-tap-mot-'+ page +'.pdf');
      self.pdfdata = pdfvuer.createLoadingTask(
        APP_CONFIG.bookCdnUrl + this.slug + "-" + page + ".pdf"
      );
      self.dynamicKey = Math.random(10000);

      // self.pdfdata = pdfvuer.createLoadingTask(APP_CONFIG.bookCdnUrl + 'toan-5-tap-mot-'+ page +'.pdf');
      //self.pdfdata = pdfvuer.createLoadingTask(APP_CONFIG.bookCdnUrl + this.slug +'.pdf');
      self.pdfdata.then((pdf) => {
        //get total page from full pdf
        //self.numPages = pdf.numPages;
        self.numPages = self.ebooksDetail.totalPage;
        self.setPageDisplay(self.ebooksDetail.totalPage);
        self.pdfObj = self;
      });
      this.page = page;
      this.renderPageHighLight();
    },

    setPageDisplay(pages) {
      let pageLoad = pages % 2 === 0 ? pages % 2 : (pages % 2) + 1;
      this.pageBookDefault =
        pages > this.eachPageDouble ? this.eachPageDouble : pageLoad;
    },

    prev() {
      var self = this;
      //self.$refs.shortcutKey.focus();
      if (self.page > 1) {
        self.page = self.page - 1;
        // self.pageBookDefault -= 1;
        self.activeFlipBook -= 1;
        setTimeout(() => {
          self.setOpacityActiveFlip -= 1;
        }, 500);
        // self.flipClass='page-flip-right';
        // self.getPdf(self.page);
        setTimeout(function () {
          self.renderPageHighLight();
          self.flipClass = "";
        }, 500);
      }
    },
    next() {
      //this.$refs.shortcutKey.focus();
      //console.log(this.$refs.myPdfComponent.pdf)
      var self = this;
      if (this.page < this.numPages) {
        // this.flipClass='page-flip-left';
        this.page = this.page + 1;
        this.pageBookDefault += 2;
        // settimeout for transition delay 0.8s
        self.activeFlipBook += 1;
        setTimeout(() => {
          self.setOpacityActiveFlip += 1;
        }, 450);
        // this.getPdf(this.page);
        var that = this;
        setTimeout(function () {
          that.renderPageHighLight();
          self.flipClass = "";
        }, 500);
      }
    },
    first() {
      //this.$refs.shortcutKey.focus();
      this.page = 1;
      this.pageBookDefault = 1;
      this.activeFlipBook = 0;
      this.setOpacityActiveFlip = 0;
      // this.getPdf(this.page);
      this.renderPageHighLight();
    },
    last() {
      //this.$refs.shortcutKey.focus();
      this.page = this.numPages;
      if (this.displayTwoPage) {
        this.pageBookDefault =
          this.numPages % 2 === 0
            ? this.numPages / 2
            : Math.floor(this.numPages / 2) + 1;
      } else {
        this.pageBookDefault = this.numPages;
      }

      this.activeFlipBook = this.pageBookDefault - 1;
      this.setOpacityActiveFlip = this.activeFlipBook;
      // this.getPdf(this.page);
      this.renderPageHighLight();
    },
    zoomIn() {
      if (this.scale <= 3) {
        this.scale = this.scale + 0.25;
        this.renderPageHighLight();
        // this.setWidthHeightBookViewer()
      }
    },
    zoomOut() {
      if (this.scale > 0.25) {
        this.scale = this.scale - 0.25;
        this.renderPageHighLight();
        // this.setWidthHeightBookViewer()
      }
    },
    fullScreen() {
      this.scale = 2;
      this.renderPageHighLight();
    },
    showPDF(pdf_url) {},
    readPage(page) {
      //console.log(this.$refs.myPdfComponent.pdf)
      if (page > 0 && page < this.numPages) {
        this.page = page + 1;
        var that = this;
        setTimeout(function () {
          that.renderPageHighLight();
        }, 1000);
      }
    },
    getSelectedText() {
      if (window.getSelection) {
        return this.TCVN3ToUnicode(window.getSelection().toString());
      } else if (document.selection) {
        return this.TCVN3ToUnicode(document.selection.createRange().text);
      }
      return "";
    },
    onMouseup() {
      var text = this.getSelectedText();
      if (text != "" && text.length > 0) {
        const selection = window.getSelection();
        const startNode = selection.getRangeAt(0).startContainer.parentNode;
        const endNode = selection.getRangeAt(0).endContainer.parentNode;
        const { x, y, width } = selection.getRangeAt(0).getBoundingClientRect();
        if (!width) {
          this.showTools = false;
          return;
        }
        this.x = x + width / 2;
        this.y = y + window.scrollY - 10;
        this.selectedText = selection.toString();

        var pdfContainer = document.getElementById("viewerContainer");
        if (
          this.x >= pdfContainer.offsetLeft &&
          this.x <= pdfContainer.offsetLeft + pdfContainer.offsetWidth &&
          this.y >= pdfContainer.offsetTop &&
          this.y <= pdfContainer.offsetTop + pdfContainer.offsetHeight
        ) {
          this.showTools = true;
        } else {
          this.showTools = false;
        }
      } else {
        this.showTools = false;
      }
    },
    handleAction(action) {
      var selection = window.getSelection();
      var getRange = selection.getRangeAt(0);
      var getRect = getRange.getBoundingClientRect();
      //console.log(getRect);
      //addHighLight();
      let __CANVAS = document.getElementById("viewerContainer");
      var arrHLs = this.getClientRects(__CANVAS, getRange);

      var arrs = this.getDictHighLight(this.page);
      var hlObj = {
        id: 0,
        content: this.getSelectedText(),
        color: this.defaultColor,
        arrHLs: arrHLs,
      };
      if (arrs != null && arrs != "undefined") {
        arrs.push(hlObj);
      } else {
        this.addDictHighLight(this.page, [hlObj]);
      }

      //console.log(arrHLs)

      var hl_container = document.createElement("div");
      hl_container.setAttribute("class", "highlight-layer");

      for (var i = 0, len = arrHLs.length; i < len; ++i) {
        hl_container.appendChild(this.createRect(arrHLs[i]));
      }
      document.getElementsByClassName("textLayer")[0].append(hl_container);
      this.renderHighLight(hlObj);
      this.$emit(action, this.selectedText);
    },
    getClientRects(containerEl, range) {
      let clientRects = Array.from(range.getClientRects());

      var offset = containerEl.getBoundingClientRect();
      let __SCALE = this.scale;
      var rects = [];
      // console.log(clientRects)
      for (var i = 0, len = clientRects.length; i < len; ++i) {
        var rect = clientRects[i];
        var obj = {};
        obj.top = rect.top + containerEl.scrollTop - offset.top;
        obj.left = rect.left + containerEl.scrollLeft - offset.left;
        obj.width = rect.width;
        obj.height = rect.height;
        rects.push(obj);
      }
      var arrRect = [];
      var _top = 0,
        _left = 0,
        _width = 0,
        _height = 0;
      for (var i = 0; i < rects.length; i++) {
        if (i == 0) {
          _top = rects[i].top;
          _left = rects[i].left;
          _width = rects[i].width;
          _height = rects[i].height;
        } else {
          if (rects[i].top > _top + 5) {
            arrRect.push({
              top: _top / __SCALE,
              left: _left / __SCALE,
              width: _width / __SCALE,
              height: _height / __SCALE,
            });
            _top = rects[i].top;
            _left = rects[i].left;
            _width = rects[i].width;
            _height = rects[i].height;
            if (_width == null || _width == "undefined") {
              _width = 0;
            }
          } else {
            if (rects[i].left > _left + 1) {
              _width = _width + rects[i].width;
            }
            if (_width > containerEl.width - _left) {
              _width = containerEl.width - _left;
            }
          }
          if (i == rects.length - 1) {
            arrRect.push({
              top: _top / __SCALE,
              left: _left / __SCALE,
              width: _width / __SCALE,
              height: _height / __SCALE,
            });
          }
        }
        if (rects.length == 1) {
          arrRect.push({
            top: _top / __SCALE,
            left: _left / __SCALE,
            width: _width / __SCALE,
            height: _height / __SCALE,
          });
        }
      }
      // console.log(rects);
      // console.log(arrRect);
      return arrRect;
      // console.log(rects);
      // return rects;
    },
    createRect(highlight, color) {
      //let __CANVAS = document.getElementById('viewerContainer')
      var myLayer = document.createElement("div");
      myLayer.setAttribute("class", "highlight");
      myLayer.style.position = "absolute";
      myLayer.style.left = this.scale * highlight.left + "px";
      myLayer.style.top = this.scale * highlight.top + "px";
      myLayer.style.width = this.scale * highlight.width + "px";
      myLayer.style.height = this.scale * highlight.height + "px";
      myLayer.style.padding = "0px";
      myLayer.style.backgroundColor = color; //'#ff0000';
      myLayer.innerHTML = "";
      return myLayer;
    },
    renderHighLight(obj) {
      var hl_container = document.createElement("div");
      hl_container.setAttribute("class", "highlight-layer");

      for (var i = 0, len = obj.arrHLs.length; i < len; ++i) {
        hl_container.appendChild(this.createRect(obj.arrHLs[i], obj.color));
      }
      document.getElementsByClassName("textLayer")[0].append(hl_container);
    },
    renderPageHighLight() {
      // console.log("renderPageHighLight")
      var arrs = this.getDictHighLight(this.page);
      // console.log(arrs)
      if (arrs != null && arrs != "undefined") {
        for (var i = 0, len = arrs.length; i < len; ++i) {
          this.renderHighLight(arrs[i]);
        }
      }
    },
    addDictHighLight(myKey, myValue) {
      this.dictHighLight[myKey] = myValue;
    },
    getDictHighLight(myKey) {
      return this.dictHighLight[myKey];
    },
    setCurrentHighLight(obj) {
      this.dictHighLight[this.page] = obj;
    },
    removeHighLight(obj) {
      var arrs = this.getDictHighLight(this.page);
      if (arrs != null && arrs != "undefined") {
        for (var i = 0; i < arrs.length; i++) {
          if (arrs[i].content === obj.content) {
            arrs.splice(i, 1);
            i--;
          }
        }
        this.addDictHighLight(this.page, arrs);
        this.$forceUpdate();
        var that = this;
        setTimeout(function () {
          that.renderPageHighLight();
        }, 1000);
      }
    },

    TCVN3ToUnicode(str) {
      var tcvnchars = [
        "μ",
        "¸",
        "¶",
        "·",
        "¹",
        "¨",
        "»",
        "¾",
        "¼",
        "½",
        "Æ",
        "©",
        "Ç",
        "Ê",
        "È",
        "É",
        "Ë",
        "®",
        "Ì",
        "Ð",
        "Î",
        "Ï",
        "Ñ",
        "ª",
        "Ò",
        "Õ",
        "Ó",
        "Ô",
        "Ö",
        "×",
        "Ý",
        "Ø",
        "Ü",
        "Þ",
        "ß",
        "ã",
        "á",
        "â",
        "ä",
        "«",
        "å",
        "è",
        "æ",
        "ç",
        "é",
        "¬",
        "ê",
        "í",
        "ë",
        "ì",
        "î",
        "ï",
        "ó",
        "ñ",
        "ò",
        "ô",
        "­",
        "õ",
        "ø",
        "ö",
        "÷",
        "ù",
        "ú",
        "ý",
        "û",
        "ü",
        "þ",
        "¡",
        "¢",
        "§",
        "£",
        "¤",
        "¥",
        "¦",
        "−",
        "¬",
        "̧",
        "̈",
      ];
      var unichars = [
        "à",
        "á",
        "ả",
        "ã",
        "ạ",
        "ă",
        "ằ",
        "ắ",
        "ẳ",
        "ẵ",
        "ặ",
        "â",
        "ầ",
        "ấ",
        "ẩ",
        "ẫ",
        "ậ",
        "đ",
        "è",
        "é",
        "ẻ",
        "ẽ",
        "ẹ",
        "ê",
        "ề",
        "ế",
        "ể",
        "ễ",
        "ệ",
        "ì",
        "í",
        "ỉ",
        "ĩ",
        "ị",
        "ò",
        "ó",
        "ỏ",
        "õ",
        "ọ",
        "ô",
        "ồ",
        "ố",
        "ổ",
        "ỗ",
        "ộ",
        "ơ",
        "ờ",
        "ớ",
        "ở",
        "ỡ",
        "ợ",
        "ù",
        "ú",
        "ủ",
        "ũ",
        "ụ",
        "ư",
        "ừ",
        "ứ",
        "ử",
        "ữ",
        "ự",
        "ỳ",
        "ý",
        "ỷ",
        "ỹ",
        "ỵ",
        "Ă",
        "Â",
        "Đ",
        "Ê",
        "Ô",
        "Ơ",
        "Ư",
        "ư",
        "ơ",
        "á",
        "ă",
      ];

      var str1 = tcvnchars.join("");
      var re = new RegExp("[" + str1 + "]", "g");
      str = str.replace(re, function (c) {
        return unichars[str1.indexOf(c)];
      });
      return str;
    },
    padZeroes(number, length) {
      var my_string = "" + number;
      while (my_string.length < length) {
        my_string = "0" + my_string;
      }
      return my_string;
    },
    luyenTap(lId) {
      this.lessonId = lId;
      this.isShowExercise = !this.isShowExercise;
    },
    setActiveLesson(page) {
      var tmpLesson = 0;
      for (var i = 0; i < this.ebooksDetail.chapters.length; i++) {
        if (tmpLesson == 0) {
          for (
            var j = 0;
            j < this.ebooksDetail.chapters[i].lessons.length;
            j++
          ) {
            if (this.ebooksDetail.chapters[i].lessons[j].page_no > page) {
              tmpLesson = this.ebooksDetail.chapters[i].lessons[j].id;
              break;
            }
          }
        } else {
          break;
        }
      }
      this.lessonId = tmpLesson;
    },
    getLesson(page) {
      var tmpLesson = 0;
      if (this.ebooksDetail.book_type_id == 1 || page < 3) return 0;
      for (var i = 0; i < this.ebooksDetail.chapters.length; i++) {
        if (tmpLesson == 0) {
          for (
            var j = 0;
            j < this.ebooksDetail.chapters[i].lessons.length;
            j++
          ) {
            if (this.ebooksDetail.chapters[i].lessons[j].page_no >= page) {
              tmpLesson = this.ebooksDetail.chapters[i].lessons[j].id;
              break;
            }
          }
        } else {
          break;
        }
      }
      return tmpLesson;
    },
    searchText() {
      //console.log("searchText")
      this.$store.dispatch(STORE_KEY + "/getBookSearch", this.textSearch);
    },
    setColor(color) {
      this.defaultColor = color;
    },
    handleSelect: function (e) {
      let value = e.target.value;
      this.selected = value;
    },
    getURL: function (sectionName = "") {
      let url = "https://api.nytimes.com/svc/search/v2/articlesearch.json";
      url += "?";
      url += `&page=${this.page}`;
      url += '&fq=source:("The New York Times")';
      if (sectionName.length > 0 && sectionName !== "all") {
        url += ` AND section_name:("${sectionName}")`;
      } else {
        url += ' AND section_name:("Multimedia/Photos")';
      }
      return (url += `&sort=newest&api-key=${this.apiKey}`);
    },
    getArticles: function (url, callback = null) {
      return fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          switch (callback) {
            case "start":
              this.resetPages = true;
              this.populateStart(json);
              setTimeout(() => {
                this.resetPages = false;
              }, 600);
              break;
            case "update":
              this.populateArticles(json);
              break;
            default:
              console.log("no callback");
              break;
          }
        });
    },

    populateArticles: function (json) {
      // const articles = json.response.docs
      // this.articles = this.articles.concat(articles)
    },

    populateStart: function (json) {
      // const articles = json.response.docs
      // this.articles = articles
    },

    changeViewBook(evt) {
      let self = this;
      self.displayTwoPage = evt.target.checked;
      if (evt.target.checked) {
        // self.scale = 0.7;
        self.pageBookDefault =
          self.numPages % 2 === 0
            ? self.activeFlipBook / 2
            : Math.floor(self.activeFlipBook / 2) + 1;
      } else {
        // self.scale = 1;
        self.pageBookDefault =
          self.activeFlipBook > 0 ? self.activeFlipBook * 2 : 1;
      }
      setTimeout(() => {
        self.scale = "page-width";
      }, 1000);
      self.activeFlipBook = self.pageBookDefault - 1;
      self.setOpacityActiveFlip = self.pageBookDefault - 1;
      self.setWidthBookDefault();
      // self.setWidthHeightBookViewer();
    },

    onKeyup(e) {
      e.keyCode === 37 && this.prev();
      e.keyCode === 39 && this.next();
    },

    getMore: function () {
      this.page++;
      // let url = this.getURL(this.selected)
      // return [{name: "test"},{name:"test"},{name:"test"}]
      return [1, 2, 3, 4, 5, 6, 7, 8, 9];
    },
  },
};
</script>

<style>
.position-rel {
  position: relative;
}
/*main-content*/
.class-name {
  color: black !important;
  font-size: 20px;
}

.class-number {
  padding: 10px 20px 0 20px;
  border-radius: 10px;
  margin-top: 24px;
}

.class-number:hover {
  background: #f3f6fb;
}

/*footer*/

.footer p {
  color: #879aa9;
  margin-top: 45px;
}

.footer li {
  color: #879aa9;
  padding-top: 5px;
}

.footer ul {
  padding: 0;
}

.footer a,
.footer p {
  font-size: 16px;
}

#footer-pate1 {
  padding-top: 80px;
  background: #f3f6fb;
}

#footer-pate1 p {
  color: #879aa9;
  padding-bottom: 35px;
}

.cool {
  padding-bottom: 128px !important;
}

#footer-buttom {
  font-size: 12px;
}

/*The end pate1*/

/*pate3*/

.on-number {
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 10px;
  background: #124abe;
  color: white;
  text-align: center;
  margin: 3px 10px 3px 3px;
}

/*pate4*/

#tab-sidebar-pate4 {
  background: #f3f6fb;
  border-top: 1px solid #cdd1d3;
  border-bottom: 1px solid #cdd1d3;
}

#menu-tab-pate4 {
  justify-content: space-between;
  padding: 20px 0;
  font-size: 14px;
  color: #879aa9;
}

.main-content-pate4 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.main-content-pate4 i {
  color: #124abe;
}

.dths {
  text-align: center;
}

.search-pen {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  color: #124abe;
}

/*footer-pate4*/

#footer-pate4 {
  background: #f3f6fb;
  color: #124abe;
  border-top: 1px solid #cdd1d3;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 75px;
  display: flex;
  align-items: center;
}

.list-exam button {
  background: #f3f6fb;
  border: none;
  color: #124abe;
  border-radius: 30px;
  width: 105px;
  height: 30px;
  margin: 10px 20px;
}

#test button {
  background: #124abe;
  color: white;
  border: none;
  border-radius: 30px;
  width: 240px;
  height: 30px;
  margin: 10px 20px;
}

#next-pate {
  display: flex;
  align-items: center;
  height: 30px;
  border-right: 1px solid #879aa9;
  margin-top: 10px;
}

#next-pate i {
  font-size: 30px;
  padding: 0 20px;
}

/*test*/

.nav-left-list {
  display: block;
  background: #f3f6fb;
  height: 640px;
  width: 300px;
  overflow: scroll;
  transition: margin-left 0.4s ease-in;
  -webkit-transition: margin-left 0.4s ease-in;
}

.nav-left-list p {
  font-size: 16px;
  color: #40505e;
  padding: 30px 0 0 30px;
}

.nav-left-list td {
  font-size: 18px;
  padding: 15px 35px;
  border-radius: 15px;
}

.list-exam-pate5 ul {
  display: flex;
  margin: 0;
}

.list-exam-pate5 li {
  padding: 0px 20px;
  margin: 0 6px;
  border-radius: 10px;
  color: #879aa9;
  cursor: pointer;
  border: 1px solid #f3f6fb;
}

.list-exam-pate5 li:hover {
  opacity: 0.7;
  border: 1px solid #879aa9;
}

#n1 {
  border: 1px solid #124abe;
}

#n1 button {
  border: 1px solid #124abe;
}

#n2 {
  background: #74dcc1;
}

#n3 {
  background: #fd6c6f;
}

.content-main-test {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.nav-left-list::-webkit-scrollbar {
  width: 8px;
  height: 0;
  background-color: #f3f6fb;
}

.nav-left-list::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #f3f6fb;
}

.nav-left-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #879aa9;
  border: 1px solid #f3f6fb;
}

.search-tab,
.table-note,
.table-link {
  background: #f3f6fb;
  height: 640px;
  overflow: scroll;
}

.tracuu {
  font-size: 20px;
  color: #40505e;
  padding: 20px 0 0 20px;
}

.search-tab input,
.table-note input,
.table-link input {
  border: unset;
  margin-left: 20px;
  width: 220px;
  height: 30px;
  border-radius: 20px;
  border: none;
  margin: 0 10px;
  font-size: 14px;
}

.search-of-right {
  background: white;
  border-radius: 20px;
  width: 270px;
  height: 30px;
  margin: 0px 15px;
}

.note-help {
  margin: 0px 0 30px;
  background: #f3f6fb;
  /* border-radius: 10px; */
  width: 280px;
}

.note-help p {
  padding: 15px 20px;
  margin: 0;
}

.icon-button {
  background: white;
  border: none !important;
  padding: 10px 10px;
  min-width: 50px;
}

#search {
  margin-top: 30px;
  outline: 0 !important;
}

.color-pen button {
  width: 30px;
  height: 30px;
  border-radius: 0;
  margin: 5px 13px;
  border: none;
}

.color-pen {
  background: #f3f6fb;
}
.color-pen .active {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}

/*content-main*/

.content-test {
  width: 300px;
  height: 592px;
  flex-grow: 1;
  text-align: center;
}

a {
  color: #879aa9;
  text-decoration: none !important;
}

/* a:hover {
        color: #124ABE !important;
    } */

#test-pate:focus {
  outline: 0;
}

.search-of-right input:focus {
  outline: 0;
}

/* HS_E-BOOK-page1 */

.list-ebook-left-1,
.list-ebook-left-2,
.list-ebook-left-3,
.list-ebook-left-4 {
  display: none;
}

.ebook-left span {
  padding: 10px 20px;
  cursor: pointer;
}

.ebook-left span:hover {
  color: #124abe;
}

.ebook-left li {
  padding: 5px 20px;
}

.chevron-next {
  padding: 0 20px;
  display: flex;
  align-items: center;
  height: calc(100vh - 145px);
  z-index: 10;
}

.chevron-next a {
  width: 30px;
}

.content-ebook {
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* margin-bottom: 40px !important; */
}
.mt-4.content-ebook {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.next-footer-ebook {
  display: flex;
  align-items: center;
}
#next-page-ebook {
  display: flex;
  align-items: center;
}

#next-page-ebook button {
  background: #124abe;
  border-radius: 20px;
  border: none;
  width: 60px;
  height: 30px;
  margin: 0 7px;
  outline: 0;
}

#next-page-ebook input {
  height: 30px;
  width: 100px;
  border-radius: 20px;
  border: none;
  margin: 0 5px;
  text-align: center;
}

#next-page-ebook i {
  color: white;
}

#zoom-ebook {
  background: white;
  border-radius: 20px;
  margin: 0 30px;
  min-width: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #c2ccd3;
  height: 40px;
}

#zoom-ebook button {
  background: white;
  /* height: 30px; */
  /* width: 30px; */
  border-radius: 20px;
  border: none;
  font-size: 26px;
  line-height: 1;
  position: relative;
  top: -4px;
  color: #c2ccd3;
  padding: 0 14px;
}
#zoom-ebook button:active,
#zoom-ebook button:focus,
#zoom-ebook button:visited {
  outline: 0;
}

#zoom-ebook input {
  width: 50px;
  border: none;
  height: 30px;
  text-align: center;
}

#zoom-ebook-full {
  background: #f3f6fb;
  border: none;
}

.fa-chevron-left,
.fa-chevron-right {
  font-size: 30px;
}

.btn-active {
  background: #f3f6fb;
}

.chapter ul {
  list-style-type: none;
  margin-left: 10px;
}

.chapter a {
  color: #212529;
  font-size: 13px;
  display: inline-block;
}

/*  .chapter a.active {
        color: #124ABE !important;
    } */

.chapter a.chapter_title {
  color: #212529;
  padding: 5px 30px;
  font-size: 13px;
  display: inline-block;
}

.ebook-left {
  max-width: 300px;
}

#carouselExampleIndicators {
  overflow: auto !important;
}

.carousel-inner {
  overflow: auto !important;
}

.book-slide {
  margin-left: auto;
  margin-right: auto;
  max-width: 1000% !important;
}

/* The whole thing */
.custom-menu {
  z-index: 1000;
  position: absolute;
  overflow: hidden;
  border: 1px solid #ccc;
  white-space: nowrap;
  font-family: sans-serif;
  background: #fff;
  color: #333;
  border-radius: 5px;
  padding: 0;
}

/* Each of the items in the list */
.custom-menu li {
  padding: 8px 12px;
  cursor: pointer;
  list-style-type: none;
  transition: all 0.3s ease;
  user-select: none;
}

.custom-menu li:hover {
  background-color: #def;
}
.tools {
  height: 30px;
  padding: 5px 10px;
  background: #333;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);
  transition: 0.2s all;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tools:after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -5px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #333;
}
.item {
  /* color: #fff; */
  cursor: pointer;
}
.item path {
  fill: #fff;
}
/*.item:hover path {
        fill: #19f;
    }
    .item:hover {
        color: #19f;
    }*/
.item + .item {
  /* margin-left: 10px; */
}

/********************************* 
    ** Thinhnv dev 
    ***********************************/
/* #main_app {min-height: 100vh!important;} */
.content-ebook {
  height: auto !important;
}
.book-container,
.book-view-single {
  position: relative;
  /* left: 50%;
        top: 50%;
        transform: translate(-50%, -50%); */
  perspective: 1000px;
  transition: all 0.3s ease-in;
  height: calc(100vh - 145px);
  display: flex;
  align-items: center;
}

.book-container {
  /* width: 430px; */
  /* height: calc(100vh - 145px); */
  /* display: flex;
        align-items: center; */
}

.book-view-single {
  /* width: 500px; */
  /* margin-bottom: 80px; */
}

.flipbook-open {
  /* margin-left: 430px; */
}
.cover {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  /* background: #d1d1d1; */
  transform: rotateY(0deg);
  transform-style: preserve-3d;
  transform-origin: left;
  transition: all 0.8s ease-in;
}

figure {
  margin: 0;
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  backface-visibility: hidden;
  /* overflow: auto; */
  overflow: hidden;
  border: 1px solid #f1f1f1;
}

.front {
  /* background: #d1d1d1; */
}
.back {
  /* background: #d1d1d1; */
  transform: rotateY(180deg);
}

.cover.flip-left {
  transform: rotateY(-180deg);
  -webkit-transform: rotateY(-180deg);
}
.book-container .cover.flip-left:first-child {
  box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.2);
}
.cover.flip-right {
  transform: rotateY(0deg);
  -webkit-transform: rotateY(0deg);
}
.cover.flip-right.flip-right-first {
  box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.2);
}
/* header {display: none!important;} */

.title-book {
  font-weight: bold;
  margin: 0;
}
.cancle-view,
.title-book {
  font-size: 18px;
}
/* .switch-viewpage {
        position: relative;
        width: 90px;
        height: 40px;
        background: #fff;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .switch-viewpage input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
        z-index: 2;
    }
    .switch-viewpage .bg-transition {
        width: 40px;
        height: 40px;
        background: #E1EFFF;
        position: absolute;
        top: 0;
        border-radius: 50%;
        display: block;
        z-index: 0;
        transition: all .3s ease-in;
        -webkit-transition: all .3s ease-in;
    }
    .switch-viewpage label {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        color: #879AA9;
        margin: 0;
        transition: all .3s ease-in;
        -webkit-transition: all .3s ease-in;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 1;
    }

    .switch-viewpage input:checked ~ .bg-transition {
        transform: translateX(50px);
    }

    .switch-viewpage input:not(:checked) ~ label.view-single {
        transform: translateX(0px);
    }

    .switch-viewpage input:checked ~ label.view-double, .switch-viewpage input:not(:checked) ~ label.view-single {
        color: #0F3DBA;
    } */

/* .show-pages {
        min-width: 130px;
        height: 40px;
        background: #fff;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #879AA9;
        font-size: 16px;
    } */
.loading-pdf {
  color: #000;
}

/* Set screen for book viewer */
/* @media screen and (device-width: 1920px) and (device-height: 1080px) {
        .book-container {
            width: 510px;
        }
        .flipbook-open {
            margin-left: 510px;
        }
    }
    @media screen and (device-width: 1680px) and (device-height: 1050px) {
        .book-container {
            width: 490px;
        }
        .flipbook-open {
            margin-left: 490px;
        }
    }

    @media screen and (device-width: 1400px) and (device-height: 1050px) {
        .book-container {
            width: 490px;
        }
        .flipbook-open {
            margin-left: 490px;
        }
    }

    @media screen and (device-width: 1600px) and (device-height: 900px) {
        .book-container {
            width: 395px;
        }
        .flipbook-open {
            margin-left: 395px;
        }
    }

    @media screen and (device-width: 1440px) and (device-height: 900px) {
        .book-container {
            width: 395px;
        }
        .flipbook-open {
            margin-left: 395px;
        }
    }
    @media screen and (device-width: 1366px) and (device-height: 768px) {
        .book-container {
            width: 310px;
        }
        .flipbook-open {
            margin-left: 310px;
        }
    }
    @media screen and (device-width: 1360px) and (device-height: 768px) {
        .book-container {
            width: 310px;
        }
        .flipbook-open {
            margin-left: 310px;
        }
    }
    @media screen and (device-width: 1280px) and (device-height: 1024px) {
        .book-container {
            width: 475px;
        }
        .flipbook-open {
            margin-left: 475px;
        }
    }

    @media screen and (device-width: 1280px) and (device-height: 960px) {
        .book-container {
            width: 430px;
        }
        .flipbook-open {
            margin-left: 430px;
        }
    }

    @media screen and (device-width: 1280px) and (device-height: 800px) {
        .book-container {
            width: 330px;
        }
        .flipbook-open {
            margin-left: 330px;
        }
    }

    @media screen and (device-width: 1280px) and (device-height: 768px) {
        .book-container {
            width: 310px;
        }
        .flipbook-open {
            margin-left: 310px;
        }
    }

    @media screen and (device-width: 1280px) and (device-height: 720px) {
        .book-container {
            width: 280px;
        }
        .flipbook-open {
            margin-left: 280px;
        }
    }

    @media screen and (device-width: 1280px) and (device-height: 600px) {
        .book-container {
            width: 215px;
            height: calc(100vh - 125px);
        }
        .flipbook-open {
            margin-left: 215px;
        }
        #menu-tab-pate4 {
            padding: 10px 0;
        }
    }

    @media screen and (device-width: 1152px) and (device-height: 864px) {
        .book-container {
            width: 370px;
        }
        .flipbook-open {
            margin-left: 370px;
        }
    }

    @media screen and (device-width: 1024px) and (device-height: 768px) {
        .book-container {
            width: 310px;
        }
        .flipbook-open {
            margin-left: 310px;
        }
    } */

/* @media screen and ( min-width: 1200px ) and ( max-width: 1600px ) {
        .book-container {
            width: 300px;
        }
        .flipbook-open {
            margin-left: 300px;
        }
    } */

/* @media screen and ( min-width: 991px ) and ( max-width: 1199px ) {
        .book-container {
            width: 245px;
        }
        .flipbook-open {
            margin-left: 245px;
        }
    } */

@media screen and (min-width: 768px) and (max-width: 991px) {
  .book-container {
    width: 290px;
  }
  .book-view-single {
    width: 450px;
    /* height: 780px; */
  }
  /* .chevron-next, .book-container {
            height: 470px;
            margin-top: 40px;
        } */
  .flipbook-open {
    margin-left: 290px;
  }
}

@media screen and (max-width: 991px) {
  .content-test {
    height: auto;
  }
  .chevron-next a {
    width: 10px;
  }
}

@media screen and (max-width: 767px) {
  .action-book {
    flex-direction: column;
  }
  #next-page-ebook {
    margin: 10px 0;
  }

  .action-right {
    margin-bottom: 10px;
  }

  #next-page-ebook button {
    width: 35px;
    margin: 0 4px;
  }
  #footer-pate4 {
    height: auto;
  }
  .chevron-next,
  .book-container {
    margin-top: 20px;
  }
}

@media screen and (min-width: 576px) and (max-width: 767px) {
  .book-container {
    width: 200px;
  }
  .chevron-next,
  .book-container,
  .book-view-single {
    /* height: 300px; */
    height: calc(100vh - 200px);
  }
  .flipbook-open {
    margin-left: 200px;
  }

  .book-view-single {
    width: 250px;
    /* width: 450px; */
    /* height: 500px; */
  }
}

@media screen and (max-width: 575px) {
  .book-container {
    width: 140px;
  }
  .chevron-next,
  .book-container,
  .book-view-single {
    /* height: 200px; */
    height: calc(100vh - 180px);
  }
  .flipbook-open {
    margin-left: 140px;
  }

  .chevron-next {
    padding: 0 10px;
  }
  .chevron-next img {
    height: 25px;
  }
  /* headerbar */
  #menu-tab-pate4 {
    padding: 8px 0;
  }
  .cancle-view,
  .title-book {
    font-size: 14px;
  }
  .cancle-view {
    margin-bottom: 10px;
    display: block;
  }

  .show-pages {
    min-width: 90px;
  }
  .show-pages,
  #zoom-ebook {
    font-size: 15px;
  }
  #zoom-ebook {
    min-width: 135px;
    margin: 0 10px;
  }
  .book-view-single {
    width: 270px;
    /* width: 270px; */
    /* height: 380px; */
    /* margin: 15px 0; */
  }
}
</style>
